exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app,body,html{height:100%}._1Y3hD{background-color:grey;height:30px}", ""]);

// exports
exports.locals = {
	"spacer": "_1Y3hD"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[hash:base64:5]!./~/postcss-loader!./client/app/style.css
 ** module id = 226
 ** module chunks = 0
 **/